import _ from 'lodash';

import BaseModel from '@/models/BaseModel';

import CategoryService from '@/services/CategoryService';

class CategoryModel extends BaseModel {
  // eslint-disable-next-line
  get defaults() {
    const baseDefaults = super.defaults;
    const defaults = {
      color_scheme: '',

      // focal_point: {
      //   x: 0,
      //   y: 0,
      // },

      id: null,

      language: 'de',

      category_id: null,

      slug: {
        slug: null,
      },

      title: '',

      teaser: '',

      image: null,

      image_id: null,

      content: '',

      parent: null,

      navigation: null,
    };

    return _.extend(baseDefaults, defaults);
  }

  save() {
    return new Promise((resolve, reject) => {
      if (this.parentCategory && !this.id) {
        CategoryService.createChild(this, this.parentCategory)
          .then((response) => {
            this.assign(response);
            return resolve(response);
          })
          .catch(err => reject(err));
      }

      if (!this.parentCategory && !this.id) {
        CategoryService.create(this)
          .then((response) => {
            this.assign(response);
            return resolve(response);
          })
          .catch(err => reject(err));
      }

      if (this.id) {
        CategoryService.update(this.id, this)
          .then((response) => {
            this.assign(response);
            return resolve(response);
          })
          .catch(err => reject(err));
      }
    });
  }
}

export default CategoryModel;
